import { createSelector } from '@ngrx/store';
import { AppState } from '../root-store.module';
import { MembersState } from './members.interfaces';

const membersState = (state: AppState) => {
  return state.members;
};

//---------1ST LEVEL SELECTORS---------
export const selectInvitation = createSelector(membersState, (state: MembersState) => state.invitation);

export const selectMembersIsLoading = createSelector(membersState, (state: MembersState) => state.isLoading);

export const selectMembersErrorMessages = createSelector(membersState, (state: MembersState) => state.errorMessages);
//---------2ND LEVEL SELECTORS---------
export const selectGetTeamMembersIsLoading = createSelector(
  selectMembersIsLoading,
  (isLoading) => isLoading['getTeamMembers']
);
export const selectGetTeamMembersErrorMessage = createSelector(
  selectMembersErrorMessages,
  (errorMessages) => errorMessages['getTeamMembers']
);

export const selectGetInvitedMembersIsLoading = createSelector(
  selectMembersIsLoading,
  (isLoading) => isLoading['getInvitedMembers']
);
export const selectGetInvitedMembersErrorMessage = createSelector(
  selectMembersErrorMessages,
  (errorMessages) => errorMessages['getInvitedMembers']
);

export const selectOnboardMemberIsLoading = createSelector(
  selectMembersIsLoading,
  (isLoading) => isLoading['onboardMember']
);
export const selectOnboardMemberErrorMessage = createSelector(
  selectMembersErrorMessages,
  (errorMessages) => errorMessages['onboardMember']
);

export const inviteMemberIsLoading = createSelector(selectMembersIsLoading, (isLoading) => isLoading['inviteMember']);
export const inviteMemberErrorMessage = createSelector(
  selectMembersErrorMessages,
  (errorMessages) => errorMessages['inviteMember']
);

export const resendInviteIsLoading = createSelector(selectMembersIsLoading, (isLoading) => isLoading['resendInvite']);
export const resendInviteErrorMessage = createSelector(
  selectMembersErrorMessages,
  (errorMessages) => errorMessages['resendInvite']
);

export const cancelInviteIsLoading = createSelector(selectMembersIsLoading, (isLoading) => isLoading['cancelInvite']);
export const cancelInviteErrorMessage = createSelector(
  selectMembersErrorMessages,
  (errorMessages) => errorMessages['cancelInvite']
);

export const selectInvitations = createSelector(membersState, (state: MembersState) => state.invitations);
export const selectTeamMembers = createSelector(membersState, (state: MembersState) => state.members);

export const selectIsLoadingInvitedMembers = createSelector(
  selectMembersIsLoading,
  (state) => state['getInvitedMembers']
);
export const selectIsLoadingTeamMembers = createSelector(
  selectMembersIsLoading,
  (isLoading) => isLoading['getTeamMembers']
);
